import React from 'react';
import { pathOr } from 'ramda';

import { setMinPrice, setMaxPrice } from '../../actions/filters';
import { FilterPrice } from '../../components/FilterPrice';
import { useDispatch, useSelector } from 'react-redux';
import { selectJsonQuery } from '../../selectors/filters/selectJsonQuery';
import { TThunkDispatch } from '../../types/redux';

export const FilterPriceContainer = () => {
  const jsonQuery = useSelector(selectJsonQuery);

  const dispatch: TThunkDispatch = useDispatch();

  return (
    <FilterPrice
      value={pathOr({}, ['price', 'value'], jsonQuery)}
      setMax={(value: number | undefined) => dispatch(setMaxPrice(value))}
      setMin={(value: number | undefined) => dispatch(setMinPrice(value))}
    />
  );
};
